/* THIS FILE IS GENERATED. DO NOT EDIT */

import { PropsFromComponent } from '@/types/component';
import ErrorBoundary from 'base/components/ErrorBoundary';
import LabradorBylineGroup from 'base/components/labrador/BylineGroup';

export const DynamicLabradorBylineGroup: typeof LabradorBylineGroup = (props) => {
    return <ErrorBoundary><LabradorBylineGroup {...props} /></ErrorBoundary>;
}
export type DynamicLabradorBylineGroupProps = PropsFromComponent<typeof LabradorBylineGroup>;
